var React = require('react');

function IconTeatroInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M25.887 0.0762939V22.5701H42.7914","stroke":"#268BAB","key":0}),React.createElement("path",{"d":"M17.9103 51.7611L17.9103 29.2673L1.00588 29.2673","stroke":"#268BAB","key":1}),React.createElement("path",{"d":"M26.387 29.9625H42.6306V38.6799C42.6306 47.7599 35.4029 55.1518 26.387 55.4163V29.9625Z","stroke":"#268BAB","key":2}),React.createElement("rect",{"x":"1.36951","y":"0.576294","width":"16.0407","height":"21.4938","stroke":"#268BAB","key":3})]);
}

IconTeatroInline.defaultProps = {"width":"44","height":"56","viewBox":"0 0 44 56","fill":"none"};

module.exports = IconTeatroInline;

IconTeatroInline.default = IconTeatroInline;
